import { createContext, useContext, useState}  from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authService } from "../../server/auth.service";

let AuthContext = createContext(null);

export function AuthProvider({ children }) {
  let [user, setUser] = useState(authService.user);

  let login = (credential, callback) => {
    return authService.login(credential, (user) => {
      setUser(user);
      callback();
    });
  };

  let logout = (callback) => {
    return authService.logout(() => {
      setUser(null);
      callback();
    });
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}

export function RequireAuth({ children }) {
  let auth = useAuth();
  let location = useLocation();

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
